import styled, {css} from 'styled-components'

import theme, {media} from '@/src/config/theme'

export const Wrapper = styled.div`
  width: 100%;

  * img {
    transition: 0.5s ease;
  }
`

export const Picture = styled.div`
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.15));
  }

  & img {
    width: 100%;
    height: auto;
    filter: brightness(0.6);
  }

  ${Wrapper}:hover & img {
    transform: scale(1.2);
  }
`
export const Title = styled.div`
  position: absolute;

  bottom: 10px;
  left: 10px;

  width: calc(100% - 10px * 2);

  color: ${theme.colors.white};
  font-size: 1.375rem;
  font-weight: 450;
  line-height: 1.2;

  text-decoration: underline;
  text-underline-offset: 4px;

  //text-shadow: 0 4px 12px rgba(0,0,0,.6);
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.6);

  ${Wrapper}:hover & {
    color: ${theme.colors.primary};
    border-bottom-color: ${theme.colors.primary};
  }

  @media ${media.md} {
    bottom: 28px;
    left: 28px;
    width: calc(100% - 28px * 2);

    font-size: 1.5rem;
  }

  @media ${media.lg} {
    font-size: 1.875rem;
  }
`
export const Time = styled.time<{$left?: boolean}>`
  display: block;
  text-align: center;
  padding: 4px 0;
  background: ${theme.colors.primaryLight};
  border-end-start-radius: 5px;
  border-start-start-radius: 5px;
  color: #000;
  line-height: 1;
  position: absolute;
  top: 20px;

  //width: 150px;
  //padding-right: 24px;
  padding-top: 4px;
  padding-bottom: 7px;
  padding-left: 26px;
  padding-right: 26px;

  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;

  left: unset;
  right: 0;

  ${props =>
    props.$left &&
    css`
      right: unset;
      left: 0;

      border-bottom-right-radius: 5px;
      border-top-right-radius: 5px;
    `}
`
